import { api } from '@/lib/api';
import type { ApiResponse, ResearchFocusArea } from '@/types';

export type ResearchUiDefaults = {
  focus_area: ResearchFocusArea;
  provider: 'openai' | 'azure_foundry' | 'azure_cognitive_services' | 'custom_o3gpt' | 'modelrouter';
};

export const RESEARCH_PROVIDER_LABELS: Record<string, string> = {
  openai: 'OpenAI o3',
  modelrouter: 'Model Router',
  azure_cognitive_services: 'Azure Cognitive',
  azure_foundry: 'Azure Foundry',
  custom_o3gpt: 'Custom O3GPT',
};

export function researchProviderLabel(provider: string): string {
  return RESEARCH_PROVIDER_LABELS[provider] ?? provider;
}

export async function loadResearchUiDefaults(): Promise<ResearchUiDefaults | null> {
  try {
    const res = await api.get<ApiResponse<ResearchUiDefaults>>('/marketing-strategies/research/ui-defaults');
    if (res.success && res.data) return res.data;
  } catch {
    /* ignore */
  }
  return null;
}
